import { RouteState } from '@circuitry-ai/doc-data';
import { PageHeader } from '@circuitry-ai/doc-ui';
import { useNavigate } from 'react-router-dom';
import FormGenieWorkerList from './FormGenieWorkerList';

export interface FormGeniePageProps {
  basePath?: string;
}

export function FormGeniePage({ basePath = '/formgenie' }: FormGeniePageProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col h-full">
      <PageHeader
        heading="FormGenie"
        description="Generate fillable forms from Universal Schemas and share them with customers."
        pageHeaderClass="!px-0"
        showCreateButton={true}
        createButtonText="Create Form Worker"
        onCreateButtonClick={() => navigate(`${basePath}/${RouteState.CREATE}?tab=configuration`)}
        entityType="uxgenie"
      />
      <div className="flex-1 overflow-y-auto">
        <FormGenieWorkerList basePath={basePath} />
      </div>
    </div>
  );
}

export default FormGeniePage;
